import { ThemeStore } from "../../../library/stores/Theme";
// @ts-ignore
window.SVGInject = require("@iconfu/svg-inject");
new ThemeStore();
